import React, { useCallback, useState } from 'react';
import './CommentCard.styles.css';
import { Comment } from './Comment';
import { CommentForm } from '../CommentForm/CommentForm';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { getToken } from '../../utils/auth';
import { Replies } from '../Replies/Replies';
import { Icons, IconsVariants } from '../../UI';
import { useAnswerCommentMutation, useReplyCommentMutation } from '../../apis';
import type { CommentResponse } from '../../types';

interface CommentCardProps {
  data: CommentResponse;
}

export const CommentCard: React.FC<CommentCardProps> = ({ data }) => {
  const replies = data.replies ?? [];
  const token = getToken();

  const [replyComment] = useReplyCommentMutation();
  const [answerComment] = useAnswerCommentMutation();

  const [expandedItem, setExpandedItem] = useState<string | null>(null);

  const toggleItem = (index: string) => {
    setExpandedItem((curr) => curr === index ? null : index);
  };

  const { questionId } = useParams<{ questionId: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const commentId = data._id;

  const requireAuth = useCallback(
    () => navigate('/login', { state: { backgroundLocation: location } }),
    [navigate, location],
  );

  const handleReply = useCallback((content: string) => {

    replyComment({ questionId: questionId!, content, commentId });
  }, [questionId, commentId, replyComment]);

  const handleCommentAnswer = useCallback(async (commentId: string, answer: boolean) => {
    answerComment({ commentId, answer });
  }, [answerComment]);

  const isExpanded = expandedItem === data._id;

  return (
    <div >
      <Comment data={data} onAnswer={handleCommentAnswer} canAct={!!token} onRequireAuth={requireAuth} />
      <div className='ml-[52px]'>
        {
          token
            ? <CommentForm onSubmit={handleReply} />
            : <button
              type="button"
              onClick={requireAuth}
              className='text-app-base text-app-secondary hover:underline py-app-sm'
            >
              Log in to reply
            </button>
        }
      </div>
      <div className='ml-[52px]'>
        {
          replies > 0
            ? <div className="divide-y divide-slate-200 ">

              <div className="">
                <div className='ml-[10px]'>
                  <button
                    type="button"
                    className="flex items-center w-full text-left font-semibold py-2 text-blue-600"
                    aria-expanded={isExpanded}
                    onClick={() => toggleItem(data._id)}
                  >
                    <Icons variant={IconsVariants.ARROW_UP}
                      classes={`transition-transform duration-500 ${expandedItem === data._id ? 'rotate-0' : 'rotate-180'}`}
                    />
                    <span className='ml-app-base '>{replies} Replies</span>
                  </button>
                </div>
                <div
                  role="region"
                  className={`grid text-sm  overflow-hidden transition-all duration-300 ease-in-out ${isExpanded
                    ? "grid-rows-[1fr] opacity-100"
                    : "grid-rows-[0fr] opacity-0"
                    }`}
                >
                  <div className="overflow-hidden">
                    {
                      expandedItem === data._id
                        ? <Replies handleAnswer={handleCommentAnswer} commentId={commentId} canAct={!!token} onRequireAuth={requireAuth} />
                        : null
                    }
                  </div>
                </div>
              </div>
            </div>

            : null
        }
      </div>
    </div>
  );
};
